<template>
  <div class="form_group">
    <label>{{ label }}</label>
    <b-form-checkbox
        :checked="normalizedValue"
        :disabled="disabled"
        :name="name"
        switch
        @change="handleChange"
    >
      {{ !hideTextValue ? value ? 'Yes' : 'No' : '' }}
    </b-form-checkbox>
  </div>
</template>

<style lang="scss">
.custom-control-input:checked ~ .custom-control-label::before {
  color: #ffffff;
  border-color: #e6007e !important;
  background-color: #e6007e !important;
}

.form_group {
  display: grid !important;
  grid-template-columns: auto !important;
}

.form_group > label {
  font-weight: bold;
  margin-bottom: 0;
}

</style>

<script>
export default {
  props: {
    name: {
      required: true
    },
    value: {
      required: true // can be true, false, "true", "false", 1, 0, or null
    },
    label: {
      type: String,
      default: ''
    },
    checkboxLabel: {
      type: String,
      default: 'Yes / No'
    },
    hideTextValue: {
      type: Boolean,
      default: false
    },
    defaultValue: {
      default: false
    },
    disabled: Boolean
  },
  computed: {
    normalizedValue() {
      // Handle null distinctly: display as unchecked, but don't coerce
      if (this.value === null) {
        this.value = this.defaultValue;
        return this.defaultValue
      }
      return this.normalize(this.value);
    }
  },
  methods: {
    normalize(val) {
      if (typeof val === 'boolean') return val
      if (typeof val === 'string') return val.toLowerCase() === 'true' || val === '1'
      if (typeof val === 'number') return val === 1
      return false
    },
    handleChange(checked) {
      // If the initial value was null, emit true/false only after interaction
      this.$emit('input', checked)
    }
  }
}
</script>
